import { ERROR_MESSAGES } from 'domain/enums'
import { getLeadByIdRequest } from 'lead/application/leads'
import { useState } from 'react'
import { useAuthProvider } from 'shared/application/hooks'
import { logMessageError } from 'shared/infrastructure/exceptions/logError'

const useGetLead = () => {
  const [lead, setLead] = useState()
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const auth = useAuthProvider()

  const getLead = async id => {
    if (lead?.id !== id) {
      setLoading(true)

      await getLeadByIdRequest(id)
        .then(response => {
          setLead(response)
        })
        .catch(err => {
          setError(true)
          if (err?.response?.status !== 401) {
            logMessageError(
              `${ERROR_MESSAGES.PROPOSAL_DETAILS} - ID: ${id}`,
              JSON.stringify(err?.response),
            )
          }
          if (err?.response?.status === 401) {
            auth.logout()
          }
        })
        .finally(() => setLoading(false))
    }
  }

  return {
    lead,
    error,
    loading,
    getLead,
  }
}

export { useGetLead }
